import { useEffect, useState, useRef, useContext } from 'react'
import API, { commonApiInvoker } from '@api/api.js'
import { IMAGE_TYPE } from '@utils/CONST'
import eventBus from "@utils/eventBus";
import Utils from "@utils/utils";
import { AppContext } from '@utils/AppContext';

export const useProjectGroupedTasks = (projectId) => {
    const { setGlobalTaskReadFlag, proSidebarValue, member, globalUser } = useContext(AppContext)
    const [groupedTasks, setGroupedTasks] = useState([])
    const [rawTasks, setRawTasks] = useState([])
    const [imageType, setImageType] = useState()
    const [resCode, setResCode] = useState(0)
    const pollingRef = useRef(null)
    const taskListInProgessingRef = useRef([])
    const isMounted = useRef(true)


    // 失败的任务弹窗提醒
    const checkAndNotifyFailedTask = (list) => {
        const taskList = list
        if (taskList) {
            for (let i = taskListInProgessingRef.current.length - 1; i >= 0; i--) {
                const taskId = taskListInProgessingRef.current[i]
                const task = taskList.find(item => item?.taskId == taskId)
                if (task) {
                    if (task.status == 'failed' || task.status == 'succeeded') {
                        taskListInProgessingRef.current.splice(i, 1)
                        if (task.status == 'failed') {
                            const error = Utils.parseErrorCode(task.errCode)
                            eventBus.emit('notification', '生成失败', error.message, 'error', error.code)
                        }
                    }
                }
            }
            const newTaskListInProgressing = taskList.filter(task => {
                return task.status != 'failed' &&
                    task.status != 'succeeded' &&
                    !taskListInProgessingRef.current.find(taskId => task.taskId == taskId)
            })
            taskListInProgessingRef.current = [
                ...taskListInProgessingRef.current,
                ...newTaskListInProgressing.map(task => task.taskId)
            ]
        }
    }

    const fetchProjectDetail = async () => {
        try {
            if (!isMounted.current) return
            const interfaceType = projectId === 'collect' ? API.listBookmarkTaskv2 : API.getProjectDetailv2
            const paramsType = projectId === 'collect' ? { module: proSidebarValue, member: member == 'team' ? null : member ? member : globalUser?.id } :
                { projectId, member: member == 'team' ? null : member ? member : globalUser?.id }


            const interfaceRes = await interfaceType(paramsType)
            const res = interfaceRes?.data
            setResCode(interfaceRes?.code)

            const allTasks = projectId === 'collect' ? (res || []) : (res?.taskList || [])
            const type = res?.imageType
            setImageType(type)
            checkAndNotifyFailedTask(allTasks)

            // const validTasks = allTasks.filter(item => item?.status !== 'failed') //去掉失败过滤
            const validTasks = allTasks

            setRawTasks(validTasks)

            const hasInProgress = allTasks.some(
                (item) => item?.status !== 'succeeded' && item?.status !== 'failed' ||
                    (item?.results?.[0]?.hdStatus === 'started' ||
                        item?.results?.[0]?.hdStatus === 'processing' ||
                        item?.results?.[0]?.hdStatus === 'pending')
            )


            // collect需要先对imagesType分组
            const imageTypeGroups = {}
            if (projectId === 'collect') {
                validTasks.forEach(item => {
                    const itemType = item?.imageType
                    if (!imageTypeGroups[itemType]) {
                        imageTypeGroups[itemType] = []
                    }
                    imageTypeGroups[itemType].push(item)
                })
            } else {
                imageTypeGroups[type] = validTasks
            }

            // 分组逻辑
            const finalGroupedTasks = []
            Object.keys(imageTypeGroups).forEach(type => {
                const tasksForType = imageTypeGroups[type]
                const groupMap = {}

                tasksForType.forEach((item) => {
                    let bkgKey = '1'
                    try {
                        bkgKey = item?.keepBkg === 0 && item?.background?.url ? new URL(item.background.url).pathname.split('/').pop() : '1'
                    } catch (e) {
                        bkgKey = item?.background?.url || '1'
                    }

                    const personKey = item?.keepPose === 0 ? (item?.person?.key || item?.person?.url) : '1'

                    let shoesKey = ''
                    try {
                        shoesKey = item?.shoesRef?.url ? new URL(item.shoesRef.url).pathname.split('/').pop() : ''
                    } catch (e) {
                        shoesKey = item?.shoesRef?.url || ''
                    }
                    const reColorKey = item?.color
                    const reClothesKey = item?.clothes
                    const modeKey = item?.mode
                    const hdModeKey = item?.hdMode
                    const inputImage = item?.inputImage
                    const modelVideoKey = item?.videoRef?.key || item?.videoRef?.url
                    const promptKey = item?.prompt
                    const poseGroupKey = item?.poseGroupKey
                    const relightModeKey = item?.relightMode
                    const relightKey = item?.relight === 0 ? 0: 1
                    const durationKey = item?.duration
                    const imageTailKey = item?.imageTail
                    const orientationKey = item?.orientation
                    const commidityKey = (item?.background?.key || item?.background?.url)
                    const resolutionAlign = item?.resolutionAlign
                    const fusionWearModelImageKey = item?.modelImage?.url
                    const fusionWearMatchImagesKey = item?.matchImages?.map(img => img?.url).join('_')

                    let groupKey = ''

                    if (type === IMAGE_TYPE.CLOTHES) {
                        const poseKey = item?.pose?.key || item?.pose?.url
                        groupKey = `${bkgKey}_${personKey}_${poseKey}_${modeKey}`
                    } else if (type === IMAGE_TYPE.MODEL || type === IMAGE_TYPE.BACKGROUND) {
                        groupKey = `${bkgKey}_${personKey}_${inputImage}_${resolutionAlign}_${relightModeKey}_${relightKey}`
                    } else if (type === IMAGE_TYPE.POSE_TRYON) {
                        const poseRefKey = item?.poseRef?.key || item?.poseRef?.url
                        groupKey = `${poseRefKey}_${inputImage}_${hdModeKey}` + modeKey + poseGroupKey
                    } else if (type === IMAGE_TYPE.GLASSES_TRYON) {
                        const glassesRefKey = item?.glassesRef?.key || item?.glassesRef?.url
                        groupKey = `${glassesRefKey}_${inputImage}_${modeKey}`
                    } else if (type === IMAGE_TYPE.SIM_TRYON) {
                        const poseRefKey = item?.poseRef?.key || item?.poseRef?.url
                        groupKey = `${poseRefKey}_${inputImage}`
                    } else if (type === IMAGE_TYPE.SHOES) {
                        groupKey = `${shoesKey}_${modeKey}`
                    } else if (type === IMAGE_TYPE.COMMODITYRECOLOR) {
                        groupKey = reColorKey + hdModeKey
                    } else if (type === IMAGE_TYPE.CLOTH_RECOLOR) {
                        groupKey = reColorKey + reClothesKey
                    } else if (type === IMAGE_TYPE.MODEL_VIDEO) {
                        groupKey = modelVideoKey + orientationKey + promptKey + modeKey
                    } else if (type === IMAGE_TYPE.IMAGE_TO_VIDEO) {
                        groupKey = durationKey + promptKey + modeKey + imageTailKey
                    } else if (type === IMAGE_TYPE.COMMODITY) {
                        groupKey = commidityKey + modeKey
                    } else if (type === IMAGE_TYPE.FUSION_WEAR) {
                        groupKey = fusionWearModelImageKey + fusionWearMatchImagesKey + promptKey + modeKey
                    } else if (type === IMAGE_TYPE.GRASS_PLANT) {
                        groupKey = item?.projectId + modeKey
                    } else {
                        groupKey = 'default'
                    }

                    if (!groupMap[groupKey]) {
                        groupMap[groupKey] = []
                    }
                    groupMap[groupKey].push(item)
                })

                finalGroupedTasks.push(...Object.values(groupMap))
            })

            setGroupedTasks(finalGroupedTasks)

            if (hasInProgress) {
                if (!pollingRef.current) {
                    pollingRef.current = setInterval(fetchProjectDetail, 1000)
                }
            } else {
                clearInterval(pollingRef.current)
                pollingRef.current = null
                // 调用一下已读标记接口
                API.setProjectReadFlag({ projectId: projectId }).then(() => {
                    setGlobalTaskReadFlag(prev => !prev)
                })
            }
        } catch (error) {
            console.error('获取项目详情失败：', error)
            clearInterval(pollingRef.current)
            pollingRef.current = null
            isMounted.current = false
        }
    }


    useEffect(() => {
        if (!projectId) return

        fetchProjectDetail()

        return () => {
            clearInterval(pollingRef.current)
            pollingRef.current = null
        }
    }, [projectId])

    return { groupedTasks, rawTasks, fetchProjectDetail, imageType, resCode }
}
